qtee.customDesign = window.qtee.customDesign || {};

/** Product details view */
qtee.customDesign.CategoriesView = Backbone.Marionette.LayoutView.extend({
	template: '/custom-design/templates/product-categories',
	regions: {
		otherStylesModalRegion: '#otherStylesModal'
	},
	ui: {
		otherStyleBtns: '.btn'
	},
	events: {
		'click @ui.otherStyleBtns': 'otherStyleClick'
	},
	modelEvents: {
		change: 'render'
	},
	otherStyleClick: function (e) {

		var style = $(e.currentTarget).data('style');

		this.showChildView(
			'otherStylesModalRegion',
			new qtee.customDesign.OtherStylesView({
				model: this.model,
				selected: style
			})
		);

		$('body').lpModal({
			lpModalClass: 'otherStylesModal largeClose',
			width: 700,
			height: 565,
			onInit: true,
			content: $(this.regions.otherStylesModalRegion)
		});

	}
});
